import vocab2 from "./indices_char";

const char2idx = {};

for (let i = 0; i < vocab2.length; i ++) {
  let char = vocab2[i];
  char2idx[char] = i;
};

export default char2idx;